import styled, { keyframes } from 'styled-components'

const animationTransitionModal = keyframes`
  from  { top:-60px; }
  to    { top:20%; }
`

export const Background = styled.div`  
  position: fixed;
  z-index: 10;
  display:flex;  
  justify-content:center;
  top: 0;
  left: 0;
  width:100vw;
  height: 100vh;  
  background: ${(props) => props.noBackgroundBlack ? `transparent` : 'rgba(0, 0, 0, 0.6)' }; ;  
`

export const StyledModal = styled.div`
  position:absolute;  
  display:flex;
  flex-flow: column wrap;
  --width: 40%;
  --height: 45%;
  margin: ${(props) => props.modalUp ? `-110px 0 0 0` : '0 10px 10px 0' };
  margin-left: 10px;
  margin-right: 10px;
  top:20%;
  background-color:white;
  animation-name: ${animationTransitionModal};
  animation-duration: 0.7s;  
  
  

  @media (min-width: 700px) 
  {
    width: 90%;
    height: 40%;
  } 
`

export const HeaderModal = styled.div`
  position:relative;
  display:flex;
  width:100%;
  --height:110px;
  height:${(props) => props.height? `${props.height}` : '110px' };
  background-color:pink;

  &:after {
    position: absolute;
    display: inline-block;
    left: 10px;
    content:${(props) => props.message? `'${props.message}'` : '' };    
    color: black;
    font-size:2.5em;
    font-family:Roboto;
    font-weight:bold;
    --top:40px;
    top:${(props) => props.topText? `${props.topText}` : '40px' };
    

  }
`

export const ContentModal = styled.div`
  display:flex;
  justify-content:center;
  align-items:center;
  flex:1;
  text-align: center;
  --padding: 10px;
`

export const FooterModal = styled.div`
  display:flex;
  width:100%;  
  ${'' /* height: 140px; */}
  align-items:center;
  justify-content:space-around;
`

export const ImgBackground = styled.img`
  width:100%;
  max-height:110px;
`

export const ContainerButtonsOther = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 15px;
  align-self: flex-end;
`
export const ContainerButtonsOne = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 15px;
  align-self: flex-end;
`

export const ButtonConfirmation = styled.button`
  display:flex;  
  width: 80px;
  height: 55px;
  align-items:center;
  justify-content:center;
  cursor: pointer;
  color: #ffffff;
  font-size: 1.2em;
  font-family:Roboto;
  font-weight:bold;
  text-transform: uppercase;
  border-radius:30px;
  border:none;
  background-color:${(props) => props.BackgroundColor? props.BackgroundColor : '#4285F4'};

  @media (min-width: 700px) 
  {
    width: 130px;
    height: 70px;
  } 
`

export const Label = styled.div`
    margin-top: 30px;

    color: #000;
    font-size: 18px;
@media (min-width: 700px) 
  {
    font-size: 32px;
  } 
`
